/**
 * Accordion — supports single-expand and multi-expand modes
 *
 * [data-accordion-single]: only one item open at a time
 * [data-accordion-multi]:  multiple items can be open simultaneously
 */

import { initCollapsible } from './collapsible.js';

export function initAccordion() {
  initCollapsible('[data-accordion-single]', '.accordion__trigger', { singleExpand: true });
  initCollapsible('[data-accordion-multi]', '.accordion__trigger');
}
